// here, create the alias to unpack in main.ts for custom svg icons

/*
The procedure for adding new icons is as follows:
1. Add the new svg file to the assets/icons folder
2. Remove the width and height attributes from the svg file
3. Add fill="currentColor" to the svg tag
4. Import the new svg file in this file
5. Add the new svg file to the return statement
*/

import nounEvents from '@/assets/icons/noun-events.svg'
import nounCalEq from '@/assets/icons/noun-calendar-eq.svg'
import nounCalDays from '@/assets/icons/noun-calendar-days.svg'
import nounToolbox from '@/assets/icons/noun-toolbox.svg'
import nounRequest from '@/assets/icons/noun-request.svg'
import nounCards from '@/assets/icons/noun-cards.svg'
import nounBell from '@/assets/icons/noun-bell.svg'
import nounStore from '@/assets/icons/noun-store.svg'
import nounKiosk from '@/assets/icons/noun-kiosk.svg'

export function getCustomIcons() {
  return {
    nounEvents,
    nounCalEq,
    nounCalDays,
    nounToolbox,
    nounRequest,
    nounCards,
    nounBell,
    nounStore,
    nounKiosk
  }
}
